module.exports = __webpack_public_path__ + "img/27f.bc47d42a.png";